import { render, staticRenderFns } from "./CustomerIndex.vue?vue&type=template&id=fe9a4b2a&scoped=true&"
import script from "./CustomerIndex.vue?vue&type=script&lang=js&"
export * from "./CustomerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9a4b2a",
  null
  
)

export default component.exports